<template>
  <div class="py-6">
    <div class="max-w-7xl px-4 sm:px-6 md:px-8">
      <PageHeader
        :title="siteSubscriberStore.siteSubscriber.name"
        :subtitle="t('siteSubscribers.editSubscriber')"
        :isLoading="siteSubscriberStore.isLoading"
      />
      <div>
        <TwoColumnForm title="">
          <ErrorMessages
            v-if="siteSubscriberStore.errors.length"
            :errors="siteSubscriberStore.errors"
          />
        </TwoColumnForm>
        <TwoColumnForm :title="t('site.title')">
          <TwoColumnFormCard><Meta /></TwoColumnFormCard
        ></TwoColumnForm>
        <TwoColumnFormDivider />
        <TwoColumnForm title=""
          ><FormSave
            :validationErrors="v$.$errors"
            :validationTouch="v$.$touch"
            storeName="siteSubscriber"
            storeAction="save"
          />
        </TwoColumnForm>
      </div>
    </div>
  </div>
</template>

<script setup>
import FormSave from '../components/FormSave.vue'
import TwoColumnForm from '../components/TwoColumnForm.vue'
import TwoColumnFormCard from '../components/TwoColumnFormCard.vue'
import TwoColumnFormDivider from '../components/TwoColumnFormDivider.vue'
import ErrorMessages from '../components/ErrorMessages.vue'
import Images from '../components/site/Images.vue'
import PageHeader from '../components/PageHeader.vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { useVuelidate } from '@vuelidate/core'
import { computed, onUnmounted } from 'vue'
import { useSiteSubscriberStore } from '../store/siteSubscriberStore'
import Meta from '../components/siteSubscriber/Meta.vue'

const siteSubscriberStore = useSiteSubscriberStore()
const route = useRoute()

const v$ = useVuelidate()

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global',
})

siteSubscriberStore.load(route.params.id)

onUnmounted(() => {
  siteSubscriberStore.$reset()
})
</script>
